import { DTPLoading } from "meu-inss-ds";
import './loading-wrapper.css';

const LoadingWrapper = ({isLoading, width="100%", height= "100%", children}) => {

    if(isLoading){
        return (
            <div className="loading-wrapper" style={{width, height}}>
                <div>
                    <DTPLoading />
                </div>
            </div>
        )
    }

    return <>{children}</>
}

export default LoadingWrapper;